import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { themeSelector, toggleTheme } from 'store/users'
import { LogoRoot, LogoIcon } from './styled'

export const Logo = () => {
  const theme = useSelector(themeSelector)

  const dispatch = useDispatch()

  useEffect(() => {
    const value = localStorage.getItem('theme')
    dispatch(toggleTheme(value))
  }, [])

  return (
    <LogoRoot>
      <LogoIcon>
        {theme === 'light' ? (
          <img src="/images/icons/DSLogoDark.svg" />
        ) : (
          <img src="/images/icons/DSLogo.svg" />
        )}
      </LogoIcon>
    </LogoRoot>
  )
}
